export const getPlaceholder = (
  isFocused: boolean,
  label?: string,
  placeholder?: string
) => {
  return label ? (isFocused ? placeholder : '') : placeholder;
};
